import {
    createNavigationContainerRef,
    StackActions,
    CommonActions,
    TabActions
} from '@react-navigation/native';
import { setGlobalState, STATE_KEYS } from '../configs/config_state';

export const navigationRef = createNavigationContainerRef();

export function navigate(name = '', params = {}) {
    if (navigationRef?.isReady() && !!name.trim()) {
        navigationRef.navigate(name, params);
    }
}

export function canGoBack() {
    if (navigationRef?.isReady()) {
        return navigationRef.canGoBack();
    }

    return false;
}

export function goBack() {
    if (navigationRef?.isReady()) {
        navigationRef.goBack();
    }
}

export function push(sceneName = '', params = {}) {
    if (navigationRef?.isReady() && !!sceneName.trim()) {
        navigationRef.dispatch(StackActions.push(sceneName, params));
    }
}

export function pop(toTop = false) {
    if (navigationRef?.isReady()) {
        const stackCount = navigationRef.getState().routes.length;
        if (toTop) {
            navigationRef.dispatch(stackCount > 1 ? StackActions.popToTop() : StackActions.pop());
        }
        else {
            navigationRef.dispatch(StackActions.pop());
        }
    }
}

export function reset(sceneName = '', params = {}) {
    if (navigationRef?.isReady() && !!sceneName.trim()) {
        navigationRef.reset({
            index: 0,
            routes: [{ name: sceneName, params }]
        });
    }
}

export function replace(sceneName = '') {
    if (navigationRef?.isReady() && !!sceneName.trim()) {
        navigationRef.dispatch(StackActions.replace(sceneName));
    }
}

export function currentRoute() {
    if (navigationRef?.isReady()) {
        return(navigationRef.getCurrentRoute());
    }
    return null;
}

export function setParams(routeKey, newParams = {}) {
    if (navigationRef?.isReady()) {
        navigationRef.dispatch({
            ...CommonActions.setParams(newParams),
            source: routeKey
        });
    }
}

export function getNavigationState() {
    if (navigationRef?.isReady()) {
        return navigationRef.getState();
    }
}

export function jumpTo(tabName = '') {
    if (navigationRef.isReady() && !!tabName.trim()) {
        navigationRef.dispatch(TabActions.jumpTo(tabName));
        setGlobalState(STATE_KEYS.CURRENT_TAB_STACK, tabName);
    }
}
